import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Linkedin, Youtube } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const Footer = () => {
  const { t, language } = useLanguage();

  return (
    <footer className="bg-obsidian border-t border-white/10 py-16">
      <div className="container mx-auto px-6 lg:px-10">
        <div className="flex flex-col md:flex-row justify-between items-start gap-8 mb-8">
          {/* Logo & Description */}
          <div className="max-w-md">
            <img 
              src="https://customer-assets.emergentagent.com/job_automate-luxury/artifacts/layrdpmr_domodomotics.png" 
              alt="Domotics Logo" 
              className="h-12 w-auto mb-4"
            />
            <p className="text-gray-400 text-sm leading-relaxed">
              {t('footer.description')}
            </p>
          </div>

          {/* Legal Links */}
          <div>
            <h3 className="text-white font-medium mb-4">
              {language === 'es' ? 'Legal' : 'Legal'}
            </h3>
            <ul className="space-y-2">
              <li>
                <Link 
                  to="/privacidad" 
                  className="text-gray-400 hover:text-brand-light transition-colors text-sm"
                >
                  {language === 'es' ? 'Política de Privacidad' : 'Privacy Policy'}
                </Link>
              </li>
              <li>
                <Link 
                  to="/cookies" 
                  className="text-gray-400 hover:text-brand-light transition-colors text-sm"
                >
                  {language === 'es' ? 'Política de Cookies' : 'Cookies Policy'}
                </Link>
              </li>
            </ul>
          </div>

          {/* Social Media - aligned right */}
          <div className="md:text-right">
            <h3 className="text-white font-medium mb-4">{t('footer.contact')}</h3>
            <div className="flex gap-4">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-blue-400 transition-colors">
                <Facebook size={24} />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-blue-400 transition-colors">
                <Instagram size={24} />
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-blue-400 transition-colors">
                <Linkedin size={24} />
              </a>
              <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-blue-400 transition-colors">
                <Youtube size={24} />
              </a>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-white/10 pt-8 text-center">
          <p className="text-gray-400 text-sm">
            © {new Date().getFullYear()} <strong className="text-white">Domotics</strong>. {t('footer.rights')}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
